export default "__VITE_ASSET__BPhyiWWc__"